import { createContext } from 'react';

export type Theme = 'classic' | 'dark' | 'coder';

export type ThemeContextType = {
  theme: Theme;
  setTheme: (theme: Theme) => void;
};

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined);
